import React, { Component } from 'react';
import axios from 'axios';
import ModalUpdateBOT from './Components/ModalUpdateBOT';
import { toast } from 'react-toastify';
import firebase from '../../components/Firebase';

export default class BOTManagerPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            botlist: [],
            bot: null,
            loading: false,
            showCreateAIDialog: false,
            showImageAlbumDialog: false,
            botQuantity: 1,
            creatingIdentityBatch: false,
            batchCreatingBots: false,
            identityRows: [],
            selectedBotForAlbum: null,
            albumImages: [],
            albumLoading: false,
            creatingAlbumImage: false,
            generatedAlbumImages: [],
            selectedAlbumModel: 'nano-banana',
            selectedAlbumQuantity: 1,
            savingAlbumImageUrl: '',
            showImagePreviewDialog: false,
            previewImageUrl: '',
            botSearchQuery: ''
        };
        this.rowKeySeed = 1;
        this.ikaraNode = firebase.database().ref("ikara");
        this.getActiveBOT = this.getActiveBOT.bind(this);
    }

    getActiveBOT() {
        let url = global.config.apiDomain + "/rest/bot-manager/get-active-bot";
        this.setState({ loading: true });
        axios.post(url)
            .then(res => {
                this.setState({
                    botlist: res.data.botlist || [],
                    loading: false
                });
            })
            .catch(() => {
                this.setState({ loading: false });
                toast.error("Không tải được danh sách BOT.");
            });
    }

    componentDidMount() {
        this.getActiveBOT();
    }

    removeIdentityRow = (rowKey) => {
        this.setState((prev) => ({
            identityRows: prev.identityRows.filter((row) => row.rowKey !== rowKey)
        }));
    };

    updateIdentityRow = (rowKey, patch) => {
        this.setState((prev) => ({
            identityRows: prev.identityRows.map((row) => (
                row.rowKey === rowKey ? { ...row, ...patch } : row
            ))
        }));
    };

    openCreateAIDialog = () => {
        this.setState({ showCreateAIDialog: true });
    };

    closeCreateAIDialog = () => {
        this.setState({ showCreateAIDialog: false });
    };

    handleQuantityChange = (value) => {
        const quantity = Number(value);
        if (Number.isNaN(quantity)) {
            this.setState({ botQuantity: 1 });
            return;
        }
        const safeQuantity = Math.min(10, Math.max(1, quantity));
        this.setState({ botQuantity: safeQuantity });
    };

    generateGuid = () => {
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
    };

    getImageExtension = (url, contentType) => {
        if (contentType) {
            if (contentType.includes('image/png')) return 'png';
            if (contentType.includes('image/jpeg')) return 'jpg';
            if (contentType.includes('image/gif')) return 'gif';
            if (contentType.includes('image/webp')) return 'webp';
        }

        const cleanUrl = (url || '').split('?')[0];
        const filePart = cleanUrl.split('/').pop() || '';
        const ext = (filePart.split('.').pop() || '').toLowerCase();
        if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) {
            return ext === 'jpeg' ? 'jpg' : ext;
        }
        return 'png';
    };

    getImageContentType = (ext) => {
        if (ext === 'jpg') return 'image/jpeg';
        if (ext === 'gif') return 'image/gif';
        if (ext === 'webp') return 'image/webp';
        return 'image/png';
    };

    putObjectToS3 = (s3, params) => new Promise((resolve, reject) => {
        s3.putObject(params, (err) => {
            if (err) {
                reject(err);
                return;
            }
            resolve();
        });
    });

    uploadAvatarUrlToData4 = async (sourceAvatarUrl) => {
        const AWS = window.AWS;
        if (!AWS || !AWS.S3) {
            throw new Error('AWS SDK chưa sẵn sàng trên trình duyệt.');
        }

        const imageRes = await fetch(sourceAvatarUrl, {
            method: 'GET',
            credentials: 'omit'
        });
        if (!imageRes.ok) {
            throw new Error(`Không tải được ảnh từ nguồn AI (${imageRes.status}).`);
        }

        const contentTypeFromHeader = imageRes.headers.get('content-type') || '';
        const imageBuffer = await imageRes.arrayBuffer();
        const ext = this.getImageExtension(sourceAvatarUrl, contentTypeFromHeader);
        const contentType = this.getImageContentType(ext);
        const keyName = `${this.generateGuid()}.${ext}`;
        const bucketName = 'ikara-data/avatars';

        const credentials = new AWS.Credentials("writeonlyuser", "awJBPnZwvVpGYmp5MDQsw3Ry7z5EsyAE");
        const ep = new AWS.Endpoint("https://data4.ikara.co:9000");
        const s3 = new AWS.S3({
            endpoint: ep,
            credentials,
            region: 'us-east-1',
            s3ForcePathStyle: true,
            httpOptions: {
                timeout: 0
            }
        });

        await this.putObjectToS3(s3, {
            ACL: 'public-read',
            ContentType: contentType,
            Bucket: bucketName,
            Key: keyName,
            Body: imageBuffer
        });

        return `https://data4.ikara.co/data/minio/${bucketName}/${keyName}`;
    };

    normalizeFirebaseImages = (imagesObj) => {
        if (!imagesObj || typeof imagesObj !== 'object') return [];
        return Object.entries(imagesObj)
            .map(([firebaseId, image]) => ({
                firebaseId,
                imageUrl: image && image.imageUrl ? image.imageUrl : '',
                dateTime: image && image.dateTime ? image.dateTime : 0
            }))
            .filter((item) => item.imageUrl)
            .sort((a, b) => Number(b.dateTime || 0) - Number(a.dateTime || 0));
    };

    fetchBotAlbumImages = (botId) => {
        if (!botId) return;
        this.setState({ albumLoading: true });
        this.ikaraNode.child('users').child(botId).child('images').get()
            .then((snapshot) => {
                const value = snapshot.val();
                this.setState({
                    albumImages: this.normalizeFirebaseImages(value),
                    albumLoading: false
                });
            })
            .catch(() => {
                this.setState({ albumLoading: false, albumImages: [] });
                toast.error("Không thể tải album ảnh BOT từ Firebase.");
            });
    };

    openBotImageAlbumDialog = (botItem) => {
        const botId = botItem && botItem.id ? botItem.id : '';
        this.setState({
            showImageAlbumDialog: true,
            selectedBotForAlbum: botItem || null,
            albumImages: [],
            generatedAlbumImages: [],
            selectedAlbumModel: 'nano-banana',
            selectedAlbumQuantity: 1,
            savingAlbumImageUrl: ''
        });
        if (botId) {
            this.fetchBotAlbumImages(botId);
        }
    };

    closeBotImageAlbumDialog = () => {
        this.setState({
            showImageAlbumDialog: false,
            selectedBotForAlbum: null,
            albumImages: [],
            generatedAlbumImages: [],
            creatingAlbumImage: false,
            selectedAlbumQuantity: 1,
            savingAlbumImageUrl: '',
            showImagePreviewDialog: false,
            previewImageUrl: ''
        });
    };

    openImagePreviewDialog = (imageUrl) => {
        if (!imageUrl) return;
        this.setState({
            showImagePreviewDialog: true,
            previewImageUrl: imageUrl
        });
    };

    closeImagePreviewDialog = () => {
        this.setState({
            showImagePreviewDialog: false,
            previewImageUrl: ''
        });
    };

    handleAlbumQuantityChange = (value) => {
        const quantity = Number(value);
        if (Number.isNaN(quantity)) {
            this.setState({ selectedAlbumQuantity: 1 });
            return;
        }
        const safeQuantity = Math.min(5, Math.max(1, quantity));
        this.setState({ selectedAlbumQuantity: safeQuantity });
    };

    createBotAlbumImages = async () => {
        const { selectedBotForAlbum, selectedAlbumModel, selectedAlbumQuantity } = this.state;
        if (!selectedBotForAlbum || !selectedBotForAlbum.id) {
            toast.warning("Không xác định BOT để tạo ảnh.");
            return;
        }
        if (!selectedBotForAlbum.avatar) {
            toast.warning("BOT chưa có avatar để làm ảnh gốc.");
            return;
        }

        this.setState({ creatingAlbumImage: true });
        try {
            let sourceAvatarUrl = selectedBotForAlbum.avatar;
            if (!sourceAvatarUrl.includes('data4.ikara.co/data/minio/')) {
                sourceAvatarUrl = await this.uploadAvatarUrlToData4(sourceAvatarUrl);
            }

            const createUrl = global.config.apiDomain + "/bot/web/bot-identity/create-image-album";
            const uploadedImages = [];
            for (let batchIndex = 0; batchIndex < selectedAlbumQuantity; batchIndex += 1) {
                const createRes = await axios.post(createUrl, {
                    model: selectedAlbumModel || 'nano-banana',
                    avatarUrl: sourceAvatarUrl
                });
                const imagesFromAI = createRes.data && Array.isArray(createRes.data.data) ? createRes.data.data : [];

                for (let i = 0; i < imagesFromAI.length; i += 1) {
                    const item = imagesFromAI[i];
                    if (!item || !item.url) continue;
                    const data4Url = await this.uploadAvatarUrlToData4(item.url);
                    uploadedImages.push({
                        sourceUrl: item.url,
                        imageUrl: data4Url,
                        note: item.note || '',
                        url_expires_at: item.url_expires_at || ''
                    });
                }
            }

            if (!uploadedImages.length) {
                this.setState({ creatingAlbumImage: false });
                toast.warning("API tạo ảnh không trả dữ liệu ảnh.");
                return;
            }

            this.setState((prev) => ({
                creatingAlbumImage: false,
                generatedAlbumImages: [...uploadedImages, ...prev.generatedAlbumImages]
            }));
            toast.success(`Đã tạo ${uploadedImages.length} ảnh mới cho BOT.`);
        } catch (error) {
            this.setState({ creatingAlbumImage: false });
            toast.error(`Tạo ảnh album thất bại: ${error && error.message ? error.message : 'Không xác định'}`);
        }
    };

    saveBotAlbumImage = async (imageUrl) => {
        const { selectedBotForAlbum } = this.state;
        if (!selectedBotForAlbum || !selectedBotForAlbum.id) {
            toast.warning("Không xác định BOT để lưu ảnh.");
            return;
        }
        if (!imageUrl) {
            toast.warning("Thiếu đường dẫn ảnh.");
            return;
        }

        this.setState({ savingAlbumImageUrl: imageUrl });
        try {
            const saveUrl = global.config.apiDomain + "/bot/web/bot-identity/save-image-album";
            await axios.post(saveUrl, {
                botId: selectedBotForAlbum.id,
                imageUrl
            });
            this.setState((prev) => ({
                generatedAlbumImages: prev.generatedAlbumImages.filter((item) => item.imageUrl !== imageUrl)
            }));
            toast.success("Đã lưu ảnh vào album BOT.");
            this.fetchBotAlbumImages(selectedBotForAlbum.id);
        } catch (error) {
            toast.error("Lưu ảnh album thất bại.");
        } finally {
            this.setState({ savingAlbumImageUrl: '' });
        }
    };

    createIdentityOne = async () => {
        const url = global.config.apiDomain + "/bot/web/bot-identity/create-draft";
        const res = await axios.post(url);
        const data = res.data || {};
        const rowKey = this.rowKeySeed;
        this.rowKeySeed += 1;
        const newRow = {
            rowKey,
            gender: data.gender || '',
            fullName: data.fullName || '',
            age: data.age || '',
            job: data.job || '',
            province: data.province || '',
            avatarUrl: data.avatarUrl || '',
            recommendedUsers: [],
            loadingRecommendedUsers: false,
            selectedStarMakerUserId: '',
            syncingStarMakerAvatar: false,
            creatingBot: false,
            createdBotId: null
        };

        this.setState((prev) => ({
            identityRows: [...prev.identityRows, newRow]
        }), () => {
            this.loadRecommendedUsersForRow(rowKey);
        });
    };

    getRecommendGenderCode = (genderValue) => {
        if (genderValue === 'male') return 1;
        if (genderValue === 'female') return 2;
        return null;
    };

    getRecommendAgeGroup = (ageValue) => {
        const ageNumber = Number(ageValue);
        if (Number.isNaN(ageNumber) || ageNumber <= 0) return '';
        return ageNumber < 40 ? 'young' : 'old';
    };

    formatVietnamTime = (ts) => {
        if (!ts && ts !== 0) return '---';
        const tsNumber = Number(ts);
        if (Number.isNaN(tsNumber) || tsNumber <= 0) return '---';
        const ms = tsNumber < 1000000000000 ? tsNumber * 1000 : tsNumber;
        try {
            return new Date(ms).toLocaleString('vi-VN', { timeZone: 'Asia/Ho_Chi_Minh' });
        } catch (error) {
            return '---';
        }
    };

    formatRecommendedUserOptionLabel = (user) => {
        if (!user) return '---';
        const name = (user.name || '---').trim();
        const shortName = name.length > 24 ? `${name.slice(0, 24)}...` : name;
        const rawId = String(user.starMakerUserId || '---');
        const shortId = rawId.length > 10 ? `${rawId.slice(0, 4)}...${rawId.slice(-4)}` : rawId;
        const recordingCount = user.recordingCount ?? 0;
        const onlineAt = this.formatVietnamTime(user.ts);
        return `${shortName} | UID ${shortId} | ${recordingCount} bài thu | ${onlineAt}`;
    };

    loadRecommendedUsersForRow = (rowKey) => {
        const { identityRows } = this.state;
        const row = identityRows.find((item) => item.rowKey === rowKey);
        if (!row) return;

        const genderCode = this.getRecommendGenderCode(row.gender);
        const ageGroup = this.getRecommendAgeGroup(row.age);

        if (!genderCode || !ageGroup) {
            this.updateIdentityRow(rowKey, {
                recommendedUsers: [],
                selectedStarMakerUserId: ''
            });
            return;
        }

        const url = global.config.apiDomain + "/bot/web/bot-identity/recommend-starmaker-users";
        this.updateIdentityRow(rowKey, { loadingRecommendedUsers: true });
        axios.post(url, {
            gender: genderCode,
            ageGroup
        })
            .then((res) => {
                const resData = res.data || {};
                const recommendList = Array.isArray(resData.starMakerUsers)
                    ? resData.starMakerUsers
                    : (resData.data && Array.isArray(resData.data.starMakerUsers) ? resData.data.starMakerUsers : []);

                this.setState((prev) => ({
                    identityRows: prev.identityRows.map((item) => {
                        if (item.rowKey !== rowKey) return item;
                        const selectedStillExists = recommendList.some((u) => u.starMakerUserId === item.selectedStarMakerUserId);
                        return {
                            ...item,
                            loadingRecommendedUsers: false,
                            recommendedUsers: recommendList,
                            selectedStarMakerUserId: selectedStillExists ? item.selectedStarMakerUserId : ''
                        };
                    })
                }));
            })
            .catch(() => {
                this.updateIdentityRow(rowKey, {
                    loadingRecommendedUsers: false,
                    recommendedUsers: [],
                    selectedStarMakerUserId: ''
                });
                toast.error("Không tải được danh sách gợi ý StarMaker.");
            });
    };

    generateIdentityBatch = async () => {
        const { botQuantity } = this.state;
        this.setState({
            creatingIdentityBatch: true,
            identityRows: []
        });

        let successCount = 0;
        for (let i = 0; i < botQuantity; i += 1) {
            try {
                await this.createIdentityOne();
                successCount += 1;
            } catch (error) {
                toast.error(`Tạo danh tính BOT ${i + 1} thất bại.`);
            }
        }

        this.setState({ creatingIdentityBatch: false });
        if (successCount > 0) {
            toast.success(`Đã tạo ${successCount}/${botQuantity} danh tính BOT.`);
        }
    };

    createSingleBot = async (rowKey) => {
        const { identityRows } = this.state;
        const row = identityRows.find((item) => item.rowKey === rowKey);
        if (!row) return Promise.resolve(false);

        const {
            gender, fullName, age, job, province, avatarUrl
        } = row;

        if (!gender || !fullName || !age || !job || !province) {
            toast.warning("Vui lòng điền đủ thông tin BOT.");
            return Promise.resolve(false);
        }

        const url = global.config.apiDomain + "/bot/web/bot-identity/save";
        this.updateIdentityRow(rowKey, { creatingBot: true });
        let finalAvatarUrl = avatarUrl || '';
        try {
            if (finalAvatarUrl && !finalAvatarUrl.includes('data4.ikara.co/data/minio/')) {
                finalAvatarUrl = await this.uploadAvatarUrlToData4(finalAvatarUrl);
                this.updateIdentityRow(rowKey, {
                    avatarUrl: finalAvatarUrl
                });
            }
        } catch (error) {
            this.updateIdentityRow(rowKey, {
                creatingBot: false
            });
            toast.error(`Upload avatar thất bại: ${error && error.message ? error.message : 'Không xác định'}`);
            return Promise.resolve(false);
        }

        return axios.post(url, {
            gender,
            fullName,
            age: Number(age),
            job,
            province,
            avatarUrl: finalAvatarUrl,
            starMakerUserId: row.selectedStarMakerUserId || null
        })
            .then((res) => {
                if (res.data && res.data.status === "OK") {
                    toast.success(`Tạo BOT thành công (ID: ${res.data.data}).`);
                    this.removeIdentityRow(rowKey);
                    this.getActiveBOT();
                    return true;
                }
                this.updateIdentityRow(rowKey, { creatingBot: false });
                toast.info("Yêu cầu đã gửi, vui lòng kiểm tra lại danh sách BOT.");
                return false;
            })
            .catch(() => {
                this.updateIdentityRow(rowKey, { creatingBot: false });
                toast.error("Không thể tạo BOT mới.");
                return false;
            });
    };

    createBatchBots = async () => {
        const { identityRows } = this.state;
        if (!identityRows.length) {
            toast.warning("Vui lòng tạo danh tính BOT trước.");
            return;
        }

        this.setState({ batchCreatingBots: true });
        let successCount = 0;
        for (let i = 0; i < identityRows.length; i += 1) {
            const row = identityRows[i];
            const isOk = await this.createSingleBot(row.rowKey);
            if (isOk) {
                successCount += 1;
            }
        }
        this.setState({ batchCreatingBots: false });
        toast.info(`Hoàn tất tạo hàng loạt: ${successCount}/${identityRows.length} BOT thành công.`);
    };

    handleIdentityRowChange = (rowKey, field, value) => {
        this.setState((prev) => ({
            identityRows: prev.identityRows.map((row) => {
                if (row.rowKey !== rowKey) return row;
                return {
                    ...row,
                    [field]: value,
                    createdBotId: null,
                    ...(field === 'gender' || field === 'age'
                        ? { selectedStarMakerUserId: '' }
                        : {})
                };
            })
        }), () => {
            if (field === 'gender' || field === 'age') {
                this.loadRecommendedUsersForRow(rowKey);
            }
        });
    };

    handleSelectStarMakerUser = (rowKey, starMakerUserId) => {
        const { identityRows } = this.state;
        const row = identityRows.find((item) => item.rowKey === rowKey);
        if (!row) return;

        const selectedUser = (row.recommendedUsers || []).find((user) => user.starMakerUserId === starMakerUserId);
        this.updateIdentityRow(rowKey, {
            selectedStarMakerUserId: starMakerUserId,
            createdBotId: null
        });

        if (!selectedUser || !selectedUser.profileImage) return;

        this.updateIdentityRow(rowKey, { syncingStarMakerAvatar: true });
        const profileImageUrl = selectedUser.profileImage;

        if (profileImageUrl.includes('data4.ikara.co/data/minio/')) {
            this.updateIdentityRow(rowKey, {
                avatarUrl: profileImageUrl,
                syncingStarMakerAvatar: false
            });
            return;
        }

        this.uploadAvatarUrlToData4(profileImageUrl)
            .then((data4AvatarUrl) => {
                this.updateIdentityRow(rowKey, {
                    avatarUrl: data4AvatarUrl,
                    syncingStarMakerAvatar: false
                });
                toast.success("Đã đồng bộ ảnh StarMaker lên data4.");
            })
            .catch((error) => {
                this.updateIdentityRow(rowKey, { syncingStarMakerAvatar: false });
                toast.error(`Đồng bộ ảnh StarMaker thất bại: ${error && error.message ? error.message : 'Không xác định'}`);
            });
    };

    render() {
        const {
            botlist,
            bot,
            loading,
            showCreateAIDialog,
            showImageAlbumDialog,
            botQuantity,
            creatingIdentityBatch,
            batchCreatingBots,
            identityRows,
            selectedBotForAlbum,
            albumImages,
            albumLoading,
            creatingAlbumImage,
            generatedAlbumImages,
            selectedAlbumModel,
            selectedAlbumQuantity,
            savingAlbumImageUrl,
            showImagePreviewDialog,
            previewImageUrl
        } = this.state;
        const totalBots = Array.isArray(botlist) ? botlist.length : 0;
        const queryNorm = (this.state.botSearchQuery || '').trim().toLowerCase();
        const filteredBotlist = !queryNorm || !Array.isArray(botlist)
            ? (botlist || [])
            : botlist.filter((item) => {
                const name = String(item.name || '').toLowerCase();
                const uid = String(item.uid != null ? item.uid : '').toLowerCase();
                return name.includes(queryNorm) || uid.includes(queryNorm);
            });
        const hasGeneratedRequestedQuantity = identityRows.length > 0 && identityRows.length >= botQuantity;
        const brand = {
            primary: '#4f46e5',
            primaryDark: '#4338ca',
            softBg: '#eef2ff',
            textMuted: '#64748b',
            border: '#e2e8f0'
        };
        const stickyHeaderStyle = {
            position: 'sticky',
            top: 0,
            zIndex: 2,
            background: '#f8fafc'
        };
        const defaultBotAvatar = 'https://ui-avatars.com/api/?name=BOT&background=e2e8f0&color=475569&bold=true';

        return (
            <>
                <ModalUpdateBOT bot={bot} botlist={botlist} onUpdated={this.getActiveBOT} />
                <div id="content">
                    <div className="container-fluid py-3 py-md-4">
                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 p-3 p-md-4" style={{ background: brand.softBg, borderRadius: "14px", border: `1px solid ${brand.border}` }}>
                            <div>
                                <h1 className="h3 font-weight-bold mb-1 text-dark">Quản lý BOT</h1>
                                <p className="mb-0" style={{ color: brand.textMuted }}>Theo dõi, chỉnh sửa và tạo BOT với giao diện quản trị tập trung.</p>
                            </div>
                            <div className="mt-2 mt-md-0">
                                <span className="badge badge-pill px-3 py-2" style={{ fontSize: "0.9rem", background: brand.primary, color: "#fff" }}>
                                    Tổng BOT: {totalBots}
                                </span>
                            </div>
                        </div>

                        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
                            <div className="card-body d-flex flex-wrap justify-content-between align-items-center">
                                <div>
                                    <h4 className="mb-1 font-weight-bold">Tạo danh tính BOT bằng AI</h4>
                                    <p className="text-muted mb-0">Mở cửa sổ để tạo và hiệu chỉnh nhiều danh tính BOT cùng lúc.</p>
                                </div>
                                <button className="btn mt-2 mt-md-0 px-4 text-white" style={{ background: brand.primary, borderColor: brand.primaryDark }} onClick={this.openCreateAIDialog}>
                                    Mở trình tạo
                                </button>
                            </div>
                        </div>

                        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                            <div className="d-flex flex-wrap align-items-center">
                                <h4 className="mb-0 font-weight-bold mr-3">Danh sách BOT hiện có</h4>
                                {loading && <span className="text-muted">Đang tải danh sách...</span>}
                                {!loading && queryNorm && (
                                    <span className="text-muted small">
                                        Hiển thị {filteredBotlist.length}/{totalBots}
                                    </span>
                                )}
                            </div>
                            <div className="input-group" style={{ maxWidth: "320px", width: "100%" }}>
                                <div className="input-group-prepend">
                                    <span className="input-group-text bg-white border-right-0">
                                        <i className="fa-solid fa-magnifying-glass text-muted" aria-hidden />
                                    </span>
                                </div>
                                <input
                                    type="search"
                                    className="form-control border-left-0"
                                    placeholder="Tìm theo tên hoặc UID..."
                                    value={this.state.botSearchQuery}
                                    onChange={(e) => this.setState({ botSearchQuery: e.target.value })}
                                    aria-label="Tìm BOT theo tên hoặc UID"
                                />
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm" style={{ borderRadius: "12px", overflow: "hidden" }}>
                            <div className="table-responsive" style={{ maxHeight: "70vh", overflow: "auto" }}>
                                <table className="table table-hover mb-0" style={{ tableLayout: "fixed", minWidth: "1255px" }}>
                                    <thead className="thead-light">
                                        <tr className="text-center">
                                            <th className="align-middle border-top-0" style={{ ...stickyHeaderStyle, width: "56px" }} scope="col">#</th>
                                            <th className="align-middle border-top-0 d-none d-lg-table-cell" style={{ ...stickyHeaderStyle, width: "170px" }} scope="col">ID</th>
                                            <th className="align-middle border-top-0 d-none d-md-table-cell" style={{ ...stickyHeaderStyle, width: "150px" }} scope="col">UID</th>
                                            <th className="align-middle border-top-0" style={{ ...stickyHeaderStyle, width: "92px" }} scope="col">Ảnh đại diện</th>
                                            <th className="align-middle border-top-0" style={{ ...stickyHeaderStyle, width: "130px" }} scope="col">Tên</th>
                                            <th className="align-middle border-top-0 d-none d-md-table-cell" style={{ ...stickyHeaderStyle, width: "74px" }} scope="col">Tuổi</th>
                                            <th className="align-middle border-top-0 d-none d-sm-table-cell" style={{ ...stickyHeaderStyle, width: "95px" }} scope="col">Giới tính</th>
                                            <th className="align-middle border-top-0 d-none d-xl-table-cell" style={{ ...stickyHeaderStyle, width: "140px" }} scope="col">Quê quán</th>
                                            <th className="align-middle border-top-0 d-none d-xl-table-cell" style={{ ...stickyHeaderStyle, width: "140px" }} scope="col">Nghề nghiệp</th>
                                            <th className="align-middle border-top-0 d-none d-lg-table-cell" style={{ ...stickyHeaderStyle, width: "188px" }} scope="col">Trạng thái</th>
                                            <th className="align-middle border-top-0" style={{ ...stickyHeaderStyle, width: "170px" }} scope="col">Thao tác</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredBotlist && filteredBotlist.map((item, index) => {
                                            return (
                                                <tr key={item.id || index}>
                                                    <td className="align-middle text-center font-weight-bold" scope="col">{index + 1}</td>
                                                    <td className="align-middle text-center d-none d-lg-table-cell" scope="col">{item.id || '---'}</td>
                                                    <td className="align-middle text-center text-monospace small d-none d-md-table-cell" scope="col">{item.uid || '---'}</td>
                                                    <td className="align-middle text-center" scope="col">
                                                        <div
                                                            className="rounded-circle overflow-hidden border bg-light mx-auto"
                                                            style={{ width: "56px", height: "56px", flexShrink: 0 }}
                                                            aria-hidden
                                                        >
                                                            <img
                                                                src={item.avatar || defaultBotAvatar}
                                                                alt=""
                                                                onError={(e) => { e.currentTarget.src = defaultBotAvatar; }}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    objectFit: "cover",
                                                                    display: "block",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                        </div>
                                                    </td>
                                                    <td className="align-middle" scope="col">
                                                        <p className="mb-0 font-weight-bold text-dark text-truncate" title={item.name || ''}>{item.name || 'Không tên'}</p>
                                                        <p className="mb-0 small d-md-none text-muted text-truncate" title={item.uid || ''}>{item.uid || '---'}</p>
                                                    </td>
                                                    <td className="align-middle text-center d-none d-md-table-cell" scope="col">{item.age || '---'}</td>
                                                    <td className="align-middle text-center d-none d-sm-table-cell" scope="col">{item.gender || '---'}</td>
                                                    <td className="align-middle text-center d-none d-xl-table-cell" scope="col">{item.hometown || '---'}</td>
                                                    <td className="align-middle text-center d-none d-xl-table-cell" scope="col">{item.occupation || '---'}</td>
                                                    <td className="align-middle text-center d-none d-lg-table-cell" scope="col">
                                                        <span className="badge badge-light border text-truncate" style={{ maxWidth: "178px", display: "inline-block", padding: "6px 10px" }} title={item.signature || ''}>
                                                            {item.signature || '---'}
                                                        </span>
                                                    </td>
                                                    <td className="align-middle text-center" scope="col">
                                                        <div className="d-flex flex-column flex-md-row justify-content-center">
                                                            <button
                                                                className='btn btn-info btn-sm mb-2 mb-md-0 mr-md-2'
                                                                data-toggle="modal"
                                                                data-target="#ModalUpdateBOT"
                                                                onClick={() => {
                                                                    this.setState({
                                                                        bot: item
                                                                    })
                                                                }}
                                                            >
                                                                Chỉnh sửa
                                                            </button>
                                                            <button
                                                                className="btn btn-outline-secondary btn-sm"
                                                                onClick={() => this.openBotImageAlbumDialog(item)}
                                                            >
                                                                Quản lý ảnh
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        {!loading && !totalBots && (
                                            <tr>
                                                <td colSpan="11" className="text-center text-muted py-4">
                                                    Chưa có BOT nào trong danh sách.
                                                </td>
                                            </tr>
                                        )}
                                        {!loading && totalBots > 0 && !filteredBotlist.length && (
                                            <tr>
                                                <td colSpan="11" className="text-center text-muted py-4">
                                                    Không có BOT khớp với từ khóa tìm kiếm.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                {showCreateAIDialog && (
                    <>
                        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(15,23,42,0.55)" }}>
                            <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document" style={{ maxWidth: "1200px" }}>
                                <div className="modal-content border-0" style={{ borderRadius: "14px", overflow: "hidden" }}>
                                    <div className="modal-header border-0 text-white" style={{ background: `linear-gradient(135deg, ${brand.primaryDark}, ${brand.primary})` }}>
                                        <div>
                                            <h5 className="modal-title font-weight-bold mb-1">Tạo danh tính BOT bằng AI</h5>
                                            <p className="mb-0 small" style={{ opacity: 0.9 }}>
                                                Tạo nhanh danh tính và chọn user StarMaker phù hợp cho từng BOT.
                                            </p>
                                        </div>
                                        <button type="button" className="close" onClick={this.closeCreateAIDialog}>
                                            <span className="text-white">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body p-3 p-md-4" style={{ maxHeight: "75vh", overflowY: "auto", background: "#f8fafc" }}>
                                        <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: "12px" }}>
                                            <div className="card-body">
                                                <div className="row align-items-end">
                                                    <div className="col-md-3">
                                                        <label className="text-muted mb-1">Số lượng BOT (1 - 10)</label>
                                                        <input
                                                            type="number"
                                                            min="1"
                                                            max="10"
                                                            className="form-control"
                                                            value={botQuantity}
                                                            onChange={(e) => this.handleQuantityChange(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-9 mt-2 mt-md-0 d-flex flex-wrap">
                                                        <button
                                                            className="btn mr-2 mb-2 mb-md-0 text-white"
                                                            style={{ background: brand.primary, borderColor: brand.primaryDark }}
                                                            disabled={creatingIdentityBatch || hasGeneratedRequestedQuantity}
                                                            onClick={this.generateIdentityBatch}
                                                        >
                                                            {creatingIdentityBatch ? "Đang tạo danh tính..." : "Tạo danh tính theo số lượng"}
                                                        </button>
                                                        <button
                                                            className="btn btn-success mb-2 mb-md-0"
                                                            disabled={batchCreatingBots || !identityRows.length}
                                                            onClick={this.createBatchBots}
                                                        >
                                                            {batchCreatingBots ? "Đang tạo BOT hàng loạt..." : "Tạo tất cả danh tính trong danh sách"}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {!identityRows.length && (
                                            <div className="alert border-0 shadow-sm" style={{ background: "#eef2ff", color: brand.primaryDark }}>
                                                Chưa có BOT nháp. Chọn số lượng và bấm "Tạo danh tính theo số lượng".
                                            </div>
                                        )}

                                        {identityRows.map((row, index) => {
                                            const selectedIdsInOtherRows = new Set(
                                                identityRows
                                                    .filter((otherRow) => otherRow.rowKey !== row.rowKey && !!otherRow.selectedStarMakerUserId)
                                                    .map((otherRow) => otherRow.selectedStarMakerUserId)
                                            );
                                            const availableRecommendedUsers = (row.recommendedUsers || []).filter(
                                                (user) => !selectedIdsInOtherRows.has(user.starMakerUserId)
                                            );
                                            return (
                                            <div key={row.rowKey} className="card border-0 shadow-sm mb-3" style={{ borderRadius: "12px" }}>
                                                <div className="card-body p-3 p-md-4">
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 pb-2 border-bottom">
                                                        <h6 className="mb-2 mb-md-0 font-weight-bold" style={{ color: brand.primaryDark }}>
                                                            BOT Nháp #{index + 1}
                                                        </h6>
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            disabled={row.creatingBot || row.syncingStarMakerAvatar}
                                                            onClick={() => this.createSingleBot(row.rowKey)}
                                                        >
                                                            {row.creatingBot ? "Đang tạo BOT..." : "Tạo BOT từ danh tính này"}
                                                        </button>
                                                    </div>

                                                    <div className="row">
                                                        <div className="col-md-8">
                                                            <div className="row">
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="text-muted mb-1">Họ và tên</label>
                                                                    <input
                                                                        className="form-control"
                                                                        value={row.fullName}
                                                                        onChange={(e) => this.handleIdentityRowChange(row.rowKey, "fullName", e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-3 mb-2">
                                                                    <label className="text-muted mb-1">Tuổi</label>
                                                                    <input
                                                                        type="number"
                                                                        min="1"
                                                                        className="form-control"
                                                                        value={row.age}
                                                                        onChange={(e) => this.handleIdentityRowChange(row.rowKey, "age", e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-3 mb-2">
                                                                    <label className="text-muted mb-1">Giới tính</label>
                                                                    <select
                                                                        className="form-control"
                                                                        value={row.gender}
                                                                        onChange={(e) => this.handleIdentityRowChange(row.rowKey, "gender", e.target.value)}
                                                                    >
                                                                        <option value="">Chọn</option>
                                                                        <option value="male">Nam</option>
                                                                        <option value="female">Nữ</option>
                                                                    </select>
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="text-muted mb-1">Nghề nghiệp</label>
                                                                    <input
                                                                        className="form-control"
                                                                        value={row.job}
                                                                        onChange={(e) => this.handleIdentityRowChange(row.rowKey, "job", e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-6 mb-2">
                                                                    <label className="text-muted mb-1">Tỉnh/Thành</label>
                                                                    <input
                                                                        className="form-control"
                                                                        value={row.province}
                                                                        onChange={(e) => this.handleIdentityRowChange(row.rowKey, "province", e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="col-md-12 mb-2">
                                                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                                                        <label className="text-muted mb-0">Người dùng StarMaker</label>
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-outline-secondary btn-sm py-0 px-2"
                                                                            style={{ fontWeight: 400 }}
                                                                            onClick={() => this.loadRecommendedUsersForRow(row.rowKey)}
                                                                            disabled={row.loadingRecommendedUsers}
                                                                        >
                                                                            {row.loadingRecommendedUsers ? 'Đang tải...' : 'Tải lại gợi ý'}
                                                                        </button>
                                                                    </div>
                                                                    <select
                                                                        className="form-control"
                                                                        value={row.selectedStarMakerUserId || ''}
                                                                        onChange={(e) => this.handleSelectStarMakerUser(row.rowKey, e.target.value)}
                                                                        disabled={row.loadingRecommendedUsers || row.syncingStarMakerAvatar}
                                                                    >
                                                                        <option value="">
                                                                            {row.loadingRecommendedUsers
                                                                                ? 'Đang tải danh sách...'
                                                                                : (row.syncingStarMakerAvatar ? 'Đang đồng bộ ảnh lên data4...' : 'Chọn người dùng StarMaker')}
                                                                        </option>
                                                                        {availableRecommendedUsers.map((user, optionIndex) => (
                                                                            <option key={user.starMakerUserId} value={user.starMakerUserId}>
                                                                                {`${optionIndex + 1}. ${this.formatRecommendedUserOptionLabel(user)}`}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {!row.loadingRecommendedUsers && !availableRecommendedUsers.length && (
                                                                        <small className="text-muted d-block mt-2">
                                                                            Không còn user khả dụng hoặc cần nhập giới tính/tuổi để hệ thống gợi ý.
                                                                        </small>
                                                                    )}
                                                                    {row.syncingStarMakerAvatar && (
                                                                        <small className="text-primary d-block mt-2">
                                                                            Đang lấy ảnh từ StarMaker và upload lên data4...
                                                                        </small>
                                                                    )}
                                                                </div>
                                                                {!!row.selectedStarMakerUserId && (
                                                                    <div className="col-md-12 mb-2">
                                                                        <div className="alert border mb-0 shadow-sm" style={{ background: "#f8fafc" }}>
                                                                            {(() => {
                                                                                const selectedUser = (row.recommendedUsers || []).find(
                                                                                    (user) => user.starMakerUserId === row.selectedStarMakerUserId
                                                                                );
                                                                                if (!selectedUser) return <span>Đã chọn user: {row.selectedStarMakerUserId}</span>;
                                                                                return (
                                                                                    <div className="d-flex align-items-center">
                                                                                        <div
                                                                                            className="rounded-circle overflow-hidden border bg-light mr-2 flex-shrink-0"
                                                                                            style={{ width: "40px", height: "40px" }}
                                                                                        >
                                                                                            <img
                                                                                                src={selectedUser.profileImage || defaultBotAvatar}
                                                                                                alt=""
                                                                                                onError={(e) => { e.currentTarget.src = defaultBotAvatar; }}
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    height: "100%",
                                                                                                    objectFit: "cover",
                                                                                                    display: "block",
                                                                                                    borderRadius: "50%"
                                                                                                }}
                                                                                            />
                                                                                        </div>
                                                                                        <div>
                                                                                            <p className="mb-0 font-weight-bold">{selectedUser.name || '---'}</p>
                                                                                            <small className="text-muted">
                                                                                                {selectedUser.recordingCount ?? 0} bài thu | Online gần nhất: {this.formatVietnamTime(selectedUser.ts)}
                                                                                            </small>
                                                                                            <br />
                                                                                            <small className="text-muted">
                                                                                                ID: {selectedUser.starMakerUserId}
                                                                                            </small>
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            {row.createdBotId && (
                                                                <p className="text-success small mb-0">Đã tạo BOT ID: {row.createdBotId}</p>
                                                            )}
                                                        </div>

                                                        <div className="col-md-4 text-center mt-3 mt-md-0">
                                                            {row.avatarUrl ? (
                                                                <div
                                                                    className="rounded-circle overflow-hidden shadow-sm mx-auto"
                                                                    style={{
                                                                        width: "150px",
                                                                        height: "150px",
                                                                        border: `3px solid ${brand.softBg}`
                                                                    }}
                                                                >
                                                                    <img
                                                                        src={row.avatarUrl}
                                                                        alt=""
                                                                        className="img-fluid"
                                                                        style={{
                                                                            width: "100%",
                                                                            height: "100%",
                                                                            objectFit: "cover",
                                                                            display: "block",
                                                                            borderRadius: "50%"
                                                                        }}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div
                                                                    className="d-flex align-items-center justify-content-center mx-auto rounded-circle bg-light text-muted border"
                                                                    style={{ width: "150px", height: "150px" }}
                                                                >
                                                                    Chưa có avatar
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )})}
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={this.closeCreateAIDialog}>
                                            Đóng
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {showImageAlbumDialog && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.4)" }}>
                        <div className="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Album ảnh BOT: {selectedBotForAlbum ? (selectedBotForAlbum.name || selectedBotForAlbum.id) : ''}
                                    </h5>
                                    <button type="button" className="close" onClick={this.closeBotImageAlbumDialog}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{ maxHeight: "75vh", overflowY: "auto" }}>
                                    <div className="card border mb-3">
                                        <div className="card-body">
                                            <div className="row align-items-end">
                                                <div className="col-md-4">
                                                    <label>Model tạo ảnh</label>
                                                    <input
                                                        className="form-control"
                                                        value={selectedAlbumModel}
                                                        onChange={(e) => this.setState({ selectedAlbumModel: e.target.value })}
                                                        placeholder="nano-banana"
                                                    />
                                                </div>
                                                <div className="col-md-3 mt-2 mt-md-0">
                                                    <label>Số lượng ảnh cần tạo</label>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        max="5"
                                                        className="form-control"
                                                        value={selectedAlbumQuantity}
                                                        onChange={(e) => this.handleAlbumQuantityChange(e.target.value)}
                                                    />
                                                </div>
                                                <div className="col-md-5 mt-2 mt-md-0">
                                                    <button
                                                        className="btn btn-primary"
                                                        disabled={creatingAlbumImage}
                                                        onClick={this.createBotAlbumImages}
                                                    >
                                                        {creatingAlbumImage ? "Đang tạo ảnh..." : "Tạo loạt ảnh mới từ avatar BOT"}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h6 className="mb-2">Avatar gốc của BOT</h6>
                                    {selectedBotForAlbum && selectedBotForAlbum.avatar ? (
                                        <div className="card border mb-3">
                                            <div className="card-body d-flex align-items-center">
                                                <img
                                                    src={selectedBotForAlbum.avatar}
                                                    alt="original bot avatar"
                                                    className="rounded mr-3"
                                                    style={{ width: "120px", height: "120px", objectFit: "cover", cursor: "zoom-in" }}
                                                    onClick={() => this.openImagePreviewDialog(selectedBotForAlbum.avatar)}
                                                />
                                                <div>
                                                    <p className="mb-1 font-weight-bold">Ảnh gốc dùng để tạo ảnh AI</p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-link p-0"
                                                        onClick={() => this.openImagePreviewDialog(selectedBotForAlbum.avatar)}
                                                    >
                                                        Xem chi tiết avatar gốc
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="alert alert-light border">BOT này chưa có avatar gốc.</div>
                                    )}

                                    <h6 className="mb-2">Ảnh mới vừa tạo (chưa lưu)</h6>
                                    {!generatedAlbumImages.length && (
                                        <div className="alert alert-light border">Chưa có ảnh mới.</div>
                                    )}
                                    {generatedAlbumImages.length > 0 && (
                                        <div className="row">
                                            {generatedAlbumImages.map((img, idx) => (
                                                <div className="col-md-4 mb-3" key={`${img.imageUrl}-${idx}`}>
                                                    <div className="card h-100">
                                                        <img
                                                            src={img.imageUrl}
                                                            className="card-img-top"
                                                            alt="generated bot album"
                                                            style={{ height: "220px", objectFit: "cover", cursor: "zoom-in" }}
                                                            onClick={() => this.openImagePreviewDialog(img.imageUrl)}
                                                        />
                                                        <div className="card-body">
                                                            {img.url_expires_at && <p className="small text-muted mb-2">AI link expire: {img.url_expires_at}</p>}
                                                            <button
                                                                className="btn btn-success btn-sm"
                                                                disabled={savingAlbumImageUrl === img.imageUrl}
                                                                onClick={() => this.saveBotAlbumImage(img.imageUrl)}
                                                            >
                                                                {savingAlbumImageUrl === img.imageUrl ? "Đang lưu..." : "Lưu vào album BOT"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}

                                    <h6 className="mb-2 mt-3">Ảnh hiện có trong Firebase</h6>
                                    {albumLoading && <div className="text-muted">Đang tải ảnh hiện có...</div>}
                                    {!albumLoading && !albumImages.length && (
                                        <div className="alert alert-light border">BOT chưa có ảnh trong `ikara/users/botId/images`.</div>
                                    )}
                                    {!albumLoading && albumImages.length > 0 && (
                                        <div className="row">
                                            {albumImages.map((img) => (
                                                <div className="col-md-3 mb-3" key={img.firebaseId}>
                                                    <div className="card h-100">
                                                        <img
                                                            src={img.imageUrl}
                                                            className="card-img-top"
                                                            alt="bot album existing"
                                                            style={{ height: "180px", objectFit: "cover", cursor: "zoom-in" }}
                                                            onClick={() => this.openImagePreviewDialog(img.imageUrl)}
                                                        />
                                                        <div className="card-body p-2">
                                                            <small className="text-muted d-block">
                                                                {img.dateTime ? new Date(img.dateTime).toLocaleString() : '---'}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={this.closeBotImageAlbumDialog}>
                                        Đóng
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {showImagePreviewDialog && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.7)" }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                            <div className="modal-content bg-dark border-0">
                                <div className="modal-header border-0">
                                    <h5 className="modal-title text-white">Xem ảnh chi tiết</h5>
                                    <button type="button" className="close text-white" onClick={this.closeImagePreviewDialog}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body text-center pt-0">
                                    <img
                                        src={previewImageUrl}
                                        alt="preview bot album"
                                        className="img-fluid rounded"
                                        style={{ maxHeight: "60vh", objectFit: "contain" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}

